import { gql } from "@apollo/client";

const BANNERS = gql`
  query banners($filter: ListBannerInput!) {
    banners(filter: $filter) {
      id
      headLine
      subHeadLine
      buttonText
      buttonLink
      images
      primaryColor
      status
      sortingPosition
      sports {
        id
      }
      role
    }
  }
`;

export default BANNERS;
